import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Tabs from "components/lib/Shared/Tabs";
import { Roles_Permissions_Constants } from "config/roles-permissions";
import TypeOfChange from "./TypeOfChange";
import CompanyOfficial from "./CompanyOfficial";
import Status from "components/PLCTABS/ApplicationReviewTab/Status";
import _get from "lodash/get";
import { ChevronRightIcon } from "components/lib/Shared/Icons/sflIcons";
import { ChevronLeftIcon } from "components/lib/Shared/Icons/sflIcons";
import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";
import { Constants } from "config/constants";
import { handleFilesUpload } from "utils/filesUtils";
import { uploadTemplateFileAsync } from "state/slices/templateFile";
import {
  editInitiatedTransactionChangeAsync,
  transactionReviewAsync,
} from "state/slices/initiateTransactionChange";
import { useToast } from "hooks/useToast";
import ReactTooltip from "react-tooltip";
import ApprovalDocuments from "./ApprovalDocument";
import SignatureDocuments from "./Signature";
import Sharecapital from "./Sharecapital";
import Approvals from "./Approvals";
export default function TransactionChange({
  batchNo,
  row,
  onComplete,
  actionType,
  setActionType,
  setUpdateTable,
}) {
  const dispatch = useDispatch();
  const {
    manageCompanyTransactions,
    dashboardPermissions,
    dashboardRoles,
    designation,
  } = useSelector((state) => state.companyDashboardSlice);
  const { initiatedTransactions, getInitiatedTransactions } = useSelector(
    (state) => state.initiatedTransactionsSlice
  );
  const { toast } = useToast(5000);
  const { comments } = useSelector((state) => state.commentsSlice);
  const [agreeToSubmit, setAgreeToSubmit] = useState(false);
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [disableSubmitBtn, setDisableSubmitBtn] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [legalDepartmentEmployees, setLegalDepartmentEmployees] = useState([]);
  const [nonLegalDepartmentEmployees, setNonLegalDepartmentEmployees] =
    useState([]);
  // const [brsRefNumber] = useState(
  //   row?.original?.orgAdminReview?.brsRefNumber || ""
  // );
  const [showOrgAdminSuccessModal, setShowOrgAdminSuccessModal] =
    useState(false);
  const { getEmployee } = useSelector((state) => state.employeeSlice);
  const [selectedFiles, setSelectedFiles] = useState({});
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const isViewMode =
    actionType === "incorporation-view" ||
    actionType === "manage-transaction-view";
  const currentUser = useSelector((state) => state.userSlice);
  useEffect(() => {
    if (getEmployee?.items) {
      setLegalDepartmentEmployees(
        getEmployee.items.filter(
          (employee) => employee.isLegalDepartment === true
        )
      );
      setNonLegalDepartmentEmployees(
        getEmployee.items.filter(
          (employee) => employee.isLegalDepartment === false
        )
      );
    }
  }, [getEmployee]);
  const filterTransaction = initiatedTransactions.items.filter(
    (transaction) =>
      transaction.batchNo === batchNo || transaction.trxRef === batchNo
  );

  const authorizationsPresent = filterTransaction.some(
    (trx) => trx?.authorizations?.length > 0
  );
  const officialsPresent = filterTransaction.some(
    (trx) => trx?.officials?.length > 0
  );

  const officialIndex = initiatedTransactions.items.findIndex(
    (item) => item?._id === row.original._id
  );

  const uniqueTransactionsByChangeType = filterTransaction.reduce(
    (acc, transaction) => {
      if (!acc[transaction.trxRef]) {
        acc[transaction.trxRef] = transaction;
      }
      return acc;
    },
    {}
  );

  const officialComments = comments.filter(
    (comment) =>
      comment?.officialId &&
      comment.officialId === row?.original._id &&
      comment?.tabName
  );
  const idTypeComments = officialComments.filter(
    (comment) =>
      comment.formName === "identificationDetails" ||
      comment.formName === "names" ||
      comment.formName === "identificationDetails" ||
      comment.formName === "isDirector"
  );
  let unresolvedComments = comments.filter((comment) => !comment.isResolved);
  const uniqueTransactionsArray = Object.values(uniqueTransactionsByChangeType);
  const viewRestrictedData = dashboardPermissions.some(
    (permission) =>
      permission.name ===
      Roles_Permissions_Constants.DASHBOARD_PERMISSIONS.VIEW_RESTRICTED_DATA
  );
  const [documents, setDocuments] = useState([]);

  const tabs = useMemo(() => {
    let baseTabs = [
      {
        id: "typeOfChange",
        label: "Type of Change",
        commentsCount: idTypeComments.length,
      },
    ];
    if (authorizationsPresent) {
      baseTabs.push({ id: "sharecapital", label: "Sharecapital" });
    }
    if (officialsPresent) {
      baseTabs.push({ id: "companyOfficial", label: "Stakeholder Details" });
    }
    baseTabs.push({ id: "approvals", label: "Approvals" });
    const docTypes = [
      { type: "CourtOrder", key: "courtOrderApprovalDocs" },
      { type: "Director", key: "directorApprovalDocs" },
      { type: "Shareholder", key: "shareholderApprovalDocs" },
      { type: "Creditor", key: "creditorApprovalDocs" },
      { type: "GazetteNotice", key: "gazetteApprovalDocs" },
    ];

    const collectedDocuments = [];
    const resolutionTabs = [];
    const signatureTab = [];

    docTypes.forEach(({ type, key }) => {
      const hasDocs = uniqueTransactionsArray.some((transaction) =>
        Object.keys(transaction).includes(key)
      );

      if (hasDocs) {
        resolutionTabs.push({
          id: `resolution${type}`,
          label: `Resolution (${type})`,
        });
        signatureTab.push({
          id: `signatureDocument`,
          label: `Signature (${type})`,
        });

        const docs = uniqueTransactionsArray
          .filter((transaction) => Object.keys(transaction).includes(key))
          .map((transaction) => transaction[key]);

        collectedDocuments.push({ type, docs, key });
      }
    });

    setDocuments(collectedDocuments);

    // Insert resolution tabs first, then signature tab
    baseTabs.push(...signatureTab);
    // baseTabs.push({ id: "signatureDocument", label: "Signature" });

    if (
      actionType !== "incorporation-view" &&
      actionType !== "manage-transaction-view"
    ) {
      baseTabs.push({ id: "confirmation", label: "Status" });
    }
    return baseTabs;
  }, [actionType, initiatedTransactions]);

  const [selectedTab, setSelectedTab] = useState(tabs[0]);
  const submitToLabel =
    unresolvedComments.length !== 0 ? "applicant" : "Next Step";
  const isFirstStep = selectedTabIndex === 0;
  const isLastStep = tabs.length - 1 === selectedTabIndex;
  let nextBtnLabel = isLastStep
    ? isViewMode
      ? "Back to Transactions Page"
      : `Submit to ${submitToLabel}`
    : isViewMode
    ? "Next Step"
    : "Confirm details";
  const isDirectorReviewOrApprove = dashboardRoles.some(
    (role) =>
      role.name === Roles_Permissions_Constants.DASHBOARD_ROLES.REVIEWER &&
      [
        Constants.APPLICANT_CAPACITIES.DIRECTOR,
        Constants.APPLICANT_CAPACITIES.DIRECTOR_SHAREHOLDER,
      ].includes(designation)
  );

  const isRegistrarReviewOrApprove = dashboardRoles.some(
    (role) =>
      role.name === Roles_Permissions_Constants.DASHBOARD_ROLES.REGISTRAR
  );

  const isLegalDepartmentReviewOrApprove = legalDepartmentEmployees.some(
    (emp) => emp.user._id === currentUser._id
  );
  const isReviewer = (() => {
    if (
      isLegalDepartmentReviewOrApprove &&
      [Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.LEGAL_REVIEW].includes(
        filterTransaction[0].status
      )
    ) {
      return true;
    }
    if (
      isDirectorReviewOrApprove &&
      [
        Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_APPROVAL,
        Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.SHAREHOLDER_APPROVAL,
        Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_APPROVAL,
      ].includes(filterTransaction[0].status)
    ) {
      return true;
    }
    if (isRegistrarReviewOrApprove) {
      return true;
    }
    return false;
  })();

  const isApprover = (() => {
    if (
      isLegalDepartmentReviewOrApprove &&
      [
        Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.LEGAL_APPROVAL,
        Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.LEGAL_REVIEW,
      ].includes(filterTransaction[0].status)
    ) {
      return true;
    }
    if (
      isDirectorReviewOrApprove &&
      [
        Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_REVIEW,
        Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.SHAREHOLDER_REVIEW,
        Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_APPROVAL,
      ].includes(filterTransaction[0].status)
    ) {
      return true;
    }
    if (isRegistrarReviewOrApprove) {
      return true;
    }

    return false;
  })();
  const goToPrevStep = () => {
    setSelectedTabIndex(selectedTabIndex - 1);
  };

  useEffect(() => {
    if (
      filterTransaction[0].status ===
      Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.CHANGES_SIGNATURE
    ) {
      setSelectedTabIndex(1);
    }
  }, [selectedTabIndex]);

  useEffect(() => {
    const tempSelectedTab = tabs[selectedTabIndex];
    if (tempSelectedTab) setSelectedTab(tempSelectedTab);
  }, [tabs, selectedTabIndex]);

  const goToNextStep = async () => {
    setSelectedTabIndex(selectedTabIndex + 1);
  };
  const handleSubmitApplication = async () => {
    try {
      if (!filterTransaction || !Array.isArray(filterTransaction)) {
        console.error(
          "filterTransaction is not properly defined or not an array."
        );
        return;
      }

      const transactionsToReview = filterTransaction.filter(
        (transaction) => transaction.isReviewInThisStep
      );
      for (const transaction of transactionsToReview) {
        let status = "";
        let toastMessage = "";
        let unresolvedComments = null;

        try {
          switch (transaction.status) {
            case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_APPROVAL:
              ({ status, toastMessage } =
                handleDirectorApproval(transaction) || {});
              break;
            case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_REVIEW_II:
            case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_REVIEW:
              ({ status, toastMessage, unresolvedComments } =
                handleDirectorApproval(transaction) || {});
              break;
            case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_APPROVAL:
              ({ status, toastMessage, unresolvedComments } =
                handleRegistrarApproval(transaction) || {});
              break;
            case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_REVIEW:
            case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_REVIEW_II:
              ({ status, toastMessage, unresolvedComments } =
                (await handleDirectorReview(transaction)) || {});
              break;
            case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
              .DIRECTOR_REVIEW_APPROVAL:
              ({ status, toastMessage, unresolvedComments } =
                (await handleAdminReview(transaction)) || {});
              break;
            case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.ADMIN_REVIEW:
              ({ status, toastMessage, unresolvedComments } =
                (await handleAdminApprove(transaction)) || {});
              break;
            case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.ADMIN_REVIEW_II:
              ({ status, toastMessage, unresolvedComments } =
                (await handleAdminReview(transaction)) || {});
              break;
            case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.BRS_REVIEW:
            case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.BRS_REVIEW_II:
              ({ status, toastMessage, unresolvedComments } =
                handleBRSReview() || {});
              break;
            case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_CS_REVIEW:
              ({ status, toastMessage, unresolvedComments } =
                handleCSReview(transaction) || {});
              break;
            case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
              .REGISTRAR_CS_APPROVAL:
              ({ status, toastMessage, unresolvedComments } =
                handleCSApproval(transaction) || {});
              break;
            case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.LEGAL_REVIEW:
              ({ status, toastMessage, unresolvedComments } =
                handleLegalDepartmentReview(transaction) || {});
              break;
            case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.LEGAL_APPROVAL:
              ({ status, toastMessage, unresolvedComments } =
                handleLegalDepartmentApproval(transaction) || {});
              break;
            case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_DR_REVIEW:
              ({ status, toastMessage, unresolvedComments } =
                handleDRReview() || {});
              break;
            case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
              .REGISTRAR_DR_APPROVAL:
              ({ status, toastMessage, unresolvedComments } =
                handleDRApproval() || {});
              break;
            default:
              console.warn(
                "Unknown status for transaction:",
                transaction.status
              );
              continue;
          }

          if (!status) {
            console.error(`Status is undefined for transaction:`, transaction);
            continue;
          }

          await dispatch(
            transactionReviewAsync({
              companyId: transaction.companyId,
              data: {
                trxRef: transaction.trxRef,
                officialId: transaction.officialId,
                status,
                infoForEmailToBeSent: {
                  name: transaction.names?.firstName ?? "N/A",
                  email: transaction.electronicAddress?.emailAddress ?? "N/A",
                  reviewer: currentUser.names?.firstName ?? "N/A",
                  companyName:
                    transaction.company?.companyName1WithSuffix ?? "N/A",
                  unresolvedCommentsCount: unresolvedComments?.length || 0,
                },
              },
            })
          );

          if (toastMessage) {
            toast("success", toastMessage);
          }
        } catch (err) {
          console.error(
            "Error processing transaction:",
            transaction.status,
            err
          );
        }
      }

      if (!showOrgAdminSuccessModal !== "ADMIN-REVIEW-II") {
        if (typeof onComplete === "function") {
          onComplete("Review is done successfully");
        } else {
        }
        // onComplete("Review is done successfully");
      }
    } catch (error) {
      console.error("Error in handleSubmitApplication:", error);
    }
  };

  const handleConfirmDetails = async () => {
    if (
      actionType === "incorporation-view" ||
      actionType === "manage-transaction-view"
    ) {
      setActionType("");
    } else {
      setSubmitting(true);
      try {
        await handleSubmitApplication();
        setUpdateTable(true);
        setActionType("");
        row?.toggleRowExpanded();
      } catch (error) {
        console.error("Error in handleConfirmDetails:", error);
      } finally {
        setSubmitting(false);
      }
    }
  };
  const checkSignatureNeeded = (transaction) => {
    const isSignatureDocsNeeded =
      (transaction.status ===
        Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_APPROVAL ||
        transaction.status ===
          Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.LEGAL_APPROVAL ||
        transaction.status ===
          Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.LEGAL_REVIEW) &&
      transaction.uploadChangeDocuments.modeType === "not-signed-documents";

    return isSignatureDocsNeeded;
  };
  const handleDirectorApproval = (transaction) => {
    let status = "";
    let toastMessage = "";
    if (unresolvedComments.length > 0) {
      status = Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_CORRECTION;
      toastMessage =
        "The Application sent back to applicant to make corrections";
    } else {
      const isSignatureCSDocNeeded = checkSignatureNeeded(transaction);
      const isDirectorSignatureDocsNeeded =
        filterTransaction[0].uploadDirectorApprovalDocs.modeType ===
        "not-signed-documents";
      if (isApprover) {
        if (legalDepartmentEmployees.length > 0) {
          status = Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.LEGAL_REVIEW;
          toastMessage = "The Application sent to Legal Department for review";
        } else if (isSignatureCSDocNeeded) {
          status = Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.CHANGES_SIGNATURE;
          toastMessage = "The Application sent to Official for signature";
        } else if (isDirectorSignatureDocsNeeded) {
          status =
            Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_APPROVAL;

          toastMessage = "The Application sent to Director for Review";
        } else {
          status =
            Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_REVIEW_APPROVAL;
          toastMessage = "The Application sent to Admin for review";
        }
      } else {
        status = Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_REVIEW;
        toastMessage = "The Application sent to Registrar for approval";
      }
    }
    return { status, toastMessage, unresolvedComments };
  };

  const handleRegistrarApproval = (transaction) => {
    let status = "";
    let toastMessage = "";

    const isSignatureDocsNeeded =
      transaction.uploadDirectorApprovalDocs.modeType ===
      "not-signed-documents";
    if (unresolvedComments.length > 0) {
      status = Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_CORRECTION;
      toastMessage =
        "The Application sent back to applicant to make corrections";
    } else {
      status = isApprover
        ? isSignatureDocsNeeded
          ? Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_SIGNATURE
          : Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_REVIEW_APPROVAL
        : Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_REVIEW;

      toastMessage = isSignatureDocsNeeded
        ? "The Application sent to Director for Signature"
        : "The Application sent to Admin for Review";
    }
    return { status, toastMessage, unresolvedComments };
  };
  const handleDirectorReview = async () => {
    let status = "";
    let toastMessage = "";

    if (unresolvedComments.length > 0) {
      status =
        Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_REVIEW_CORRECTIONS;
      toastMessage =
        "The Application sent back to applicant to make corrections";
    } else {
      status =
        Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_REVIEW_APPROVAL;
      toastMessage = "The Application sent to Org Admin for review";
    }

    return { status, toastMessage, unresolvedComments };
  };

  const handleAdminReview = async () => {
    let status = "";
    let toastMessage = "";
    if (unresolvedComments.length > 0) {
      await orgAdminReviewI();
      status = Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.ADMIN_CORRECTIONS;
      toastMessage =
        "The Application sent back to applicant to make corrections";
      return { status, toastMessage };
    } else {
      await orgAdminReviewI();
      status = isApprover
        ? Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.BRS_FORM_SIGNATURE
        : Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.ADMIN_REVIEW;
      toastMessage = "The Application is Submitted";
      return { status, toastMessage, unresolvedComments };
    }
  };
  const handleAdminApprove = async () => {
    let status = "";
    let toastMessage = "";
    if (unresolvedComments.length > 0) {
      await orgAdminReviewI();
      status = Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.ADMIN_CORRECTIONS;
      toastMessage =
        "The Application sent back to applicant to make corrections";
      return { status, toastMessage };
    } else {
      await orgAdminReviewI();
      status = Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.BRS_FORM_SIGNATURE;
      toastMessage = "The Application is Submitted for  Registrar Signature";
      return { status, toastMessage, unresolvedComments };
    }
  };

  const handleBRSReview = () => {
    let status = "";
    let toastMessage = "";

    if (unresolvedComments.length > 0) {
      status = Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.BRS_REVIEW_CORRECTION;
      toastMessage =
        "The Application sent back to applicant to make corrections";
    } else {
      // orgAdminReviewII();
      status = isApprover
        ? Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.PROCESSED
        : (toastMessage = "The Application is Successfully Processed");
    }
    return { status, toastMessage, unresolvedComments };
  };

  const handleCSReview = (transaction) => {
    let status = "";
    let toastMessage = "";

    if (unresolvedComments.length > 0) {
      status =
        Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
          .CHANGES_SIGNATURE_CORRECTIONS;
      toastMessage =
        "The Application sent back to applicant to make corrections";
    } else {
      const isDirectorSignatureDocsNeeded =
        transaction.uploadDirectorApprovalDocs.modeType ===
        "not-signed-documents";
      status = isApprover
        ? isDirectorSignatureDocsNeeded
          ? Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_APPROVAL
          : Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_REVIEW_APPROVAL
        : Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_CS_APPROVAL;
      toastMessage = "The Application is Submitted Successfully";
    }
    return { status, toastMessage, unresolvedComments };
  };
  const handleCSApproval = (transaction) => {
    let status = "";
    let toastMessage = "";

    if (unresolvedComments.length > 0) {
      status =
        Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
          .CHANGES_SIGNATURE_CORRECTIONS;
      toastMessage =
        "The Application sent back to applicant to make corrections";
    } else {
      const isDirectorSignatureDocsNeeded =
        transaction.uploadDirectorApprovalDocs.modeType ===
        "not-signed-documents";
      status = isDirectorSignatureDocsNeeded
        ? Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_APPROVAL
        : Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_REVIEW_APPROVAL;
      toastMessage = "The Application is Submitted Successfully";
    }
    return { status, toastMessage, unresolvedComments };
  };
  const handleDRReview = () => {
    let status = "";
    let toastMessage = "";

    if (unresolvedComments.length > 0) {
      status =
        Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
          .DIRECTOR_SIGNATURE_CORRECTIONS;
      toastMessage =
        "The Application sent back to applicant to make corrections";
    } else {
      status = isApprover
        ? Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_REVIEW_APPROVAL
        : Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_DR_APPROVAL;
      toastMessage = isApprover
        ? "The Application is Submitted for Admin for Review"
        : "The Application is Submitted for Registrar for Approve";
    }
    return { status, toastMessage, unresolvedComments };
  };
  const handleDRApproval = () => {
    let status = "";
    let toastMessage = "";

    if (unresolvedComments.length > 0) {
      status =
        Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
          .DIRECTOR_SIGNATURE_CORRECTIONS;
      toastMessage =
        "The Application sent back to applicant to make corrections";
    } else {
      status =
        Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_REVIEW_APPROVAL;
      toastMessage = "The Application is Submitted for Admin for Review";
    }
    return { status, toastMessage, unresolvedComments };
  };
  const handleLegalDepartmentReview = (transaction) => {
    let status = "";
    let toastMessage = "";
    if (unresolvedComments.length > 0) {
      status = Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.LEGAL_CORRECTION;
      toastMessage =
        "The Application sent back to applicant to make corrections";
    } else {
      const isSignatureDocsNeeded = checkSignatureNeeded(transaction);
      const isDirectorSignatureDocsNeeded =
        transaction.uploadDirectorApprovalDocs.modeType ===
        "not-signed-documents";

      isApprover
        ? isSignatureDocsNeeded
          ? (status =
              Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.CHANGES_SIGNATURE)
          : isDirectorSignatureDocsNeeded
          ? (status =
              Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_APPROVAL)
          : (status =
              Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
                .DIRECTOR_REVIEW_APPROVAL)
        : (status = Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.LEGAL_APPROVAL);

      toastMessage = isSignatureDocsNeeded
        ? "The Application sent to Official for signature"
        : isDirectorSignatureDocsNeeded
        ? "The Application sent to Director for review"
        : "The Application sent to Admin for review";
    }
    return { status, toastMessage, unresolvedComments };
  };
  const handleLegalDepartmentApproval = (transaction) => {
    let status = "";
    let toastMessage = "";
    if (unresolvedComments.length > 0) {
      status = Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_CORRECTION;
      toastMessage =
        "The Application sent back to applicant to make corrections";
    } else {
      const isSignatureDocsNeeded =
        Constants.MAINTAIN_COMPANY_SIGNATURE_WORKFLOW.includes(
          transaction.status
        ) &&
        transaction.changeDocumentSignature.required &&
        Object.keys(transaction.changeDocumentSignature.fileUploads).length ===
          0;
      const isDirectorSignatureDocsNeeded =
        transaction.uploadDirectorApprovalDocs.modeType ===
        "not-signed-documents";
      isSignatureDocsNeeded
        ? (status =
            Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.CHANGES_SIGNATURE)
        : isDirectorSignatureDocsNeeded
        ? (status =
            Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_APPROVAL)
        : (status =
            Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
              .DIRECTOR_REVIEW_APPROVAL);
      toastMessage = isSignatureDocsNeeded
        ? "The Application sent to Official for signature"
        : isDirectorSignatureDocsNeeded
        ? "The Application sent to Director for review"
        : "The Application sent to Admin for review";
    }
    return { status, toastMessage, unresolvedComments };
  };

  function createUploadFilePayloads(uploadedFiles, companyId, officialId) {
    return Object.keys(uploadedFiles).map((key) => {
      return {
        company: companyId,
        official: officialId,
        fileType: key,
        fileName: uploadedFiles[key],
        modeType: "pre-signed-documents",
        subModeType: "self-resolution-type",
      };
    });
  }
  const orgAdminReviewI = async (transaction) => {
    const files = {
      Cr6Form: selectedFiles.selectedFiles.Cr6Form,
      Cr8Form: selectedFiles.selectedFiles.Cr8Form,
      BoDResolutionsChanges: selectedFiles.selectedFiles.BoDResolutionsChanges,
    };

    try {
      const uploadedFiles = await handleFilesUpload(files);
      const uploadFilePayloads = createUploadFilePayloads(
        uploadedFiles,
        transaction.companyId,
        transaction.officialId
      );

      const uploadPromises = uploadFilePayloads.map((payload) =>
        dispatch(uploadTemplateFileAsync({ data: payload })).then(
          (result) => result.payload.document._id
        )
      );

      const uploadedFilesDataIds = await Promise.all(uploadPromises);

      const orgAdminReviewPayload = {
        brsRefNumber: transaction.orgAdminReview?.brsRefNumber || "",
        fileUploads: uploadedFilesDataIds,
        resolvedFields: [],
        documentId: row.original._id,
      };

      await dispatch(
        editInitiatedTransactionChangeAsync({
          companyId: transaction.companyId,
          formData: orgAdminReviewPayload,
        })
      );
      return "Org Admin Review updated successfully";
    } catch (error) {
      console.error("Error in orgAdminReviewI:", error);
      throw error;
    }
  };

  return (
    <>
      <div className="overflow-x-auto mb-5">
        <Tabs
          tabs={tabs}
          selectedTabIndex={selectedTabIndex}
          setSelectedTabIndex={setSelectedTabIndex}
          showTooltip
        />
      </div>
      {selectedTab.id === "typeOfChange" && (
        <TypeOfChange
          uniqueTransactionsArray={uniqueTransactionsArray}
          actionType={actionType}
        />
      )}
      {selectedTab.id === "sharecapital" && <Sharecapital />}
      {selectedTab.id === "companyOfficial" && (
        <CompanyOfficial
          transactions={filterTransaction}
          actionType={actionType}
          goToNextStep={goToNextStep}
        />
      )}
      {selectedTab.id === "approvals" && (
        <Approvals
          transactions={filterTransaction}
          documents={documents}
          officialIndex={officialIndex}
          actionType={actionType}
        />
      )}

      {selectedTab.id === "signatureDocument" && (
        <SignatureDocuments
          transactions={filterTransaction}
          selectedTab="Signature"
          documentData={documents.find((doc) => doc.type === "Signature")}
          documentType="directorApprovalDocs"
          actionType={actionType}
        />
      )}
      {selectedTab.id === "confirmation" && (
        <Status
          submitToLabel={submitToLabel}
          setDisableSubmitBtn={setDisableSubmitBtn}
          agreeToSubmit={agreeToSubmit}
          agreeToTerms={agreeToTerms}
          setAgreeToSubmit={setAgreeToSubmit}
          setAgreeToTerms={setAgreeToTerms}
        />
      )}
      <div className="flex justify-between">
        {!isFirstStep && (
          <button
            onClick={goToPrevStep}
            className="flex items-start float-right py-2 font-semibold rounded text-primary mt-7"
          >
            <span className="flex items-center mr-4 h-7">
              <ChevronLeftIcon
                className="flex-shrink-0 w-5 h-5"
                aria-hidden="true"
              />
            </span>
            <p className="font-semibold">Go back</p>
          </button>
        )}
        {isLastStep ? (
          <div className="relative inline-block">
            <button
              data-tip={
                !isViewMode && (!agreeToSubmit || !agreeToTerms)
                  ? "Please agree to the terms and conditions to enable this action"
                  : ""
              }
              data-for="button-tooltip"
              onClick={() => handleConfirmDetails()}
              disabled={
                actionType !== "incorporation-view" &&
                actionType !== "manage-transaction-view" &&
                (submitting || !agreeToSubmit || !agreeToTerms)
              }
              className={`flex items-center px-4 py-2 mb-2 font-semibold mt-7
              ${
                actionType !== "incorporation-view" &&
                actionType !== "manage-transaction-view" &&
                (!agreeToSubmit || !agreeToTerms)
                  ? "cursor-not-allowed text-white rounded bg-green-focused/20"
                  : "hover:bg-green-600 hover:shadow-lg text-white rounded bg-green-focused"
              } // Hover only when enabled
            `}
            >
              <p>
                {submitting ? (
                  <div className="flex">
                    <SpinnerIcon />
                    submitting...
                  </div>
                ) : (
                  nextBtnLabel
                )}
              </p>
              {!isViewMode && (
                <span className="flex items-center ml-4 text-white h-7">
                  <ChevronRightIcon
                    className="flex-shrink-0 w-5 h-5"
                    aria-hidden="true"
                  />
                </span>
              )}
            </button>

            <ReactTooltip
              id="button-tooltip"
              place="bottom"
              type="dark"
              effect="solid"
              delayHide={500}
              delayShow={100}
            />
          </div>
        ) : (
          <button
            onClick={goToNextStep}
            className="flex items-start float-right py-2 ml-auto font-semibold rounded text-primary mt-7"
          >
            <p className="font-semibold">Next step</p>
            <span className="flex items-center ml-4 h-7">
              <ChevronRightIcon
                className="flex-shrink-0 w-5 h-5"
                aria-hidden="true"
              />
            </span>
          </button>
        )}
      </div>
    </>
  );
}
